import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import {
  Button,
  Group,
  SegmentedControl,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconArrowLeft,
  IconArrowRight,
  IconList,
  IconSearch,
} from "@tabler/icons-react";
import OvhDomainSearch from "./OvhDomainSearch";
import OvhDomainList from "./OvhDomainList";

const OvhStep2 = ({
  setActiveStep,
  apiKey,
  domain,
  setDomain,
  buyDomain,
  setBuyDomain,
  domainSearch,
  setDomainSearch,
  details,
  setDetails,
}) => {
  const lang = useLanguage((s) => s.language);

  const handleNext = () => {
    setActiveStep(2);
  };

  const handlePrev = () => {
    setActiveStep(0);
  };

  return (
    <>
      <Title order={2}>{lang.ovh.step2.title}</Title>
      <Text size="md">{lang.ovh.step2.text}</Text>

      <SegmentedControl
        data={[
          {
            label: (
              <Group h={32} justify="center">
                <IconSearch size={18} /> <Text>{lang.ovh.step2.search}</Text>{" "}
              </Group>
            ),
            value: "search",
          },
          {
            label: (
              <Group h={32} justify="center">
                <IconList size={18} /> <Text>{lang.ovh.step2.my_domains}</Text>{" "}
              </Group>
            ),
            value: "list",
          },
        ]}
        value={buyDomain ? "search" : "list"}
        onChange={(v) => {
          setBuyDomain(v === "search" ? true : false);
        }}
        size="md"
      />

      {buyDomain ? (
        <OvhDomainSearch
          apiKey={apiKey}
          domain={domain}
          setDomain={setDomain}
          domainSearch={domainSearch}
          setDomainSearch={setDomainSearch}
          details={details}
          setDetails={setDetails}
        />
      ) : (
        <OvhDomainList apiKey={apiKey} domain={domain} setDomain={setDomain} />
      )}

      <Group mt={"auto"} justify="space-between" gap={32}>
        <Button
          leftSection={<IconArrowLeft />}
          size="md"
          w={150}
          onClick={handlePrev}
          variant="outline"
        >
          {lang.global.back}
        </Button>

        <Tooltip label={lang.ovh.step2.verify_first} disabled={!!domain}>
          <Button
            rightSection={<IconArrowRight />}
            size="md"
            onClick={handleNext}
            flex={1}
            disabled={!domain}
          >
            {lang.ovh.step2.use_domain} {domain || " -"}
          </Button>
        </Tooltip>
      </Group>
    </>
  );
};

export default OvhStep2;
